/* src/app/multimedia/multimedia.component.css */
.styling {
  margin-top: 5rem;
}
/*# sourceMappingURL=multimedia.component.css.map */
